import get from 'lodash/get';
import {InviteMobileAccountData, InviteMobileState, InviteMobileUser} from './_contracts/invite-mobile.state';
import {getRootStore} from '../../app.bootstrap';
import {InviteMobileController} from './InviteMobileController';
import {SmsService} from '../../services/SmsService';
import {InviteEventsLogger} from '../../states/invite-new/invite.flow.logger';
import {IRouteStore} from '../../router/routing.infra';

export class InviteMobileStores implements IRouteStore {
    public inviteMobileController!: InviteMobileController;
    public localizationService: any;

    constructor(accountData: InviteMobileAccountData, currentUser: InviteMobileUser) {
        const state = new InviteMobileState(currentUser, accountData);
        const rootStore = getRootStore();

        this.localizationService = rootStore.localizationService;

        const inviteFlowLogger = new InviteEventsLogger(
            rootStore.eventsLogService,
            String(accountData._id),
            String(currentUser._id),
            {
                keepCustomerMobile: Boolean(get(accountData, 'protectedSettings.keepCustomerMobile'))
            }
        );

        const smsService = new SmsService(
            rootStore.smsApiService,
            rootStore.roomService,
            get(accountData, 'protectedSettings.smsSettings') as any,
            inviteFlowLogger,
            rootStore.browserUtilsService,
            Boolean(get(accountData, 'protectedSettings.inviteMethodSettings.allowSendByWhatsApp'))
        );

        this.inviteMobileController = new InviteMobileController(state, {
            roomService: rootStore.roomService,
            shortUrlService: rootStore.shortUrlService,
            eventLogService: rootStore.eventLogService,
            redirectionService: rootStore.redirectionService,
            browserUtilsService: rootStore.browserUtilsService,
            authService: rootStore.authService,
            tsAppUserService: rootStore.tsAppUserService,
            appState: rootStore.appState,
            smsService: smsService,
            observationsService: rootStore.observationsService,
            tsInterfaceHelperService: rootStore.tsInterfaceHelperService,
            tsLocaleHelper: rootStore.tsLocaleHelper,
            environmentService: rootStore.environmentService,
            chatApi: rootStore.chatApi,
            eventsLogService: rootStore.eventsLogService,
            userService: rootStore.userService,
            window: rootStore.globals.window,
            socketManager: rootStore.socketManager,
            displayTabletAsDesktop: Boolean(rootStore.displayTabletAsDesktop)
        });

        // Initialize sub-controllers (controller manages its own setup)
        this.inviteMobileController.initializeSubControllers();
    }

    dispose(): void {
        if (this.inviteMobileController) {
            this.inviteMobileController.dispose();
        }
    }
}
